"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToHilPackageFunctionSignal = mapToHilPackageFunctionSignal;
exports.mapFromHilPackageFunctionSignal = mapFromHilPackageFunctionSignal;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
function mapToHilPackageFunctionSignal(componentFunctionSignal) {
    return {
        optional: componentFunctionSignal.optional ?? null,
        isMultiAssignment: componentFunctionSignal.isMultiAssignment ?? null,
        busType: componentFunctionSignal.busType ?? null,
        signalTypes: componentFunctionSignal.signalTypes ?? null,
        signalIds: componentFunctionSignal.signals.flatMap((relativeSignal) => sigma_engine_shared_1.Utils.toArray(relativeSignal.signal)),
        description: componentFunctionSignal.description ?? null,
        classSignalDescription: componentFunctionSignal.classSignalDescription ?? null,
        alternateNames: componentFunctionSignal.alternateNames ?? null,
        maxAssignments: componentFunctionSignal.maxAssignments ?? null,
    };
}
function mapFromHilPackageFunctionSignal(functionClassSignalName, hilPackageFunctionSignal) {
    return {
        name: functionClassSignalName,
        optional: hilPackageFunctionSignal.optional ?? undefined,
        isMultiAssignment: hilPackageFunctionSignal.isMultiAssignment ?? undefined,
        busType: hilPackageFunctionSignal.busType ?? undefined,
        signalTypes: hilPackageFunctionSignal.signalTypes ?? undefined,
        signals: hilPackageFunctionSignal.signalIds.map((signalId) => ({ signal: signalId })),
        description: hilPackageFunctionSignal.description ?? undefined,
        classSignalDescription: hilPackageFunctionSignal.classSignalDescription ?? undefined,
        alternateNames: hilPackageFunctionSignal.alternateNames ?? undefined,
        maxAssignments: hilPackageFunctionSignal.maxAssignments ?? undefined,
    };
}
//# sourceMappingURL=package-function-signal.mapper.js.map